<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn color="success" @click="closeSign">
        <v-icon>close</v-icon>
        {{ $t(`enrollments.continue_registration`) }}
      </v-btn>
      <v-toolbar-title>{{ $t(`enrollments.e_doc_signature`) }}</v-toolbar-title>
      <v-progress-linear
        :indeterminate="true"
        color="accent"
        height="5"
        v-if="loadingFrame"
      >
      </v-progress-linear>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          v-if="action === 'SHOW'"
          :loading="loadingFrame"
          :disabled="loadingFrame"
          dark
          flat
          @click="loadSign">{{ $t(`enrollments.upload_display`) }}</v-btn>
        <v-btn
          v-else
          :loading="loadingFrame"
          :disabled="loadingFrame || loadButtonDisabled"
          dark
          flat
          @click="loadSign">{{ $t(`enrollments.upload_signature`) }}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex v-if="action === 'SHOW'" xs12>
        <embed
          class="iframe"
          :src="url"
          type="application/pdf"
          @load="loadedIframe"
        >
      </v-flex>
      <v-flex v-else xs12>
        <iframe
          class="iframe"
          v-if="documentId && documentId !== 0"
          @load="loadedIframe"
          :src="url"
          frameborder="0"
          allow="camera *;"
        ></iframe>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    name: 'digital-sign-component',
    props: {
      studentId: {
        type: [String, Number],
        required: false
      },
      documentId: {
        type: [String, Number],
        required: false
      },
      action: {
        type: [String, Number],
        required: false,
      },
      processId: {
        type: [String, Number],
        required: false
      },
      recordId: {
        type: [String, Number],
        required: false
      }
    },
    data() {
      return {
        url: '',
        url_base: window.config.vistaUrl,
        API_params: {
          Key: 'Q09MVU1CVVM=',
          App: 'ENROLLMENTS',
          Action: '',
          IdDocument: '',
          IdStudent: '',
          IdRecord: '',
          IdProcess: '',
        },
        stringParams: '',
        loadingFrame: false,
        loadButtonDisabled: false,
      }
    },
    watch: {
      studentId(newValue, oldValue) {
        this.setParams()
      },
      action(newValue, oldValue) {
        this.setParams()
      },
      documentId(newValue, oldValue) {
        this.setParams()
      },
      processId(newValue, oldValue) {
        this.setParams()
      },
      recordId(newValue, oldValue) {
        this.setParams()
      },
      paramsReadyToSet(newValue, oldValue) {
        if (newValue && !oldValue && !this.loadingFrame) {
          this.setParams()
          this.setStringParams()
        } else {
          this.stringParams = ''
        }
      },
      requestReadyToSend(newValue, oldValue) {
        if (newValue && !oldValue && !this.loadingFrame) {
          this.loadSign()
        } else {
          this.stringParams = ''
        }
      }
    },
    computed: {
      apiAction() {
        let action = ''
        if (this.action === 'CREATE') action = 'N'
        if (this.action === 'UPDATE') action = 'M'
        return action
      },
      fullUrl() {
        let url_part = ''
        if (this.action === 'CREATE') url_part = 'Create'
        if (this.action === 'UPDATE') url_part = 'Create'
        if (this.action === 'SHOW') url_part = 'ViewDocument'

        return `${this.url_base}${url_part}${this.stringParams}`
      },
      IdDocumentIsSet() {
        return this.API_params.IdDocument
          && this.API_params.IdDocument.trim() !== ''
          && this.API_params.IdDocument !== '0'
          && this.API_params.IdDocument !== 0
      },
      IdStudentIsSet() {
        return this.API_params.IdStudent
          && this.API_params.IdStudent.trim() !== ''
          && this.API_params.IdStudent !== '0'
          && this.API_params.IdStudent !== 0
      },
      IdProcessIsSet() {
        return this.API_params.IdProcess
          && this.API_params.IdProcess.trim() !== ''
          && this.API_params.IdProcess !== '0'
          && this.API_params.IdProcess !== 0
      },
      IdRecordIsSet() {
        return this.API_params.IdRecord
          && this.API_params.IdRecord.trim() !== ''
          && this.API_params.IdRecord !== '0'
          && this.API_params.IdRecord !== 0
      },
      paramsReadyToSet() {
        let ready = false

        if (this.action === 'CREATE') {
          if (this.IdDocumentIsSet && this.IdStudentIsSet && this.IdProcessIsSet) {
            ready = true
          }
        }
        if (this.action === 'UPDATE') {
          if (this.IdDocumentIsSet && this.IdStudentIsSet && this.IdProcessIsSet && this.IdRecordIsSet) {
            ready = true
          }
        }
        if (this.action === 'SHOW') {
          if (this.IdRecordIsSet) {
            ready = true
          }
        }

        return ready
      },
      requestReadyToSend() {
        return this.stringParams !== ''
      }
    },
    methods: {
      setParams() {
        this.API_params.Action = `${this.apiAction}`
        this.API_params.IdDocument = `${this.documentId}`
        this.API_params.IdStudent = `${this.studentId}`
        this.API_params.IdProcess = `${this.processId}`
        this.API_params.IdRecord = `${this.recordId}`
      },
      setStringParams() {
        if (this.paramsReadyToSet) {
          this.stringParams = this.action === 'CREATE' || this.action === 'UPDATE'
            ? `?jsonData=${JSON.stringify(this.API_params)}`
            : `?id=${this.recordId}`
        }
      },
      loadedIframe(e) {
        this.loadingFrame = false
        this.loadButtonDisabled = true
      },
      loadSign() {
        this.loadingFrame = true
        this.url = this.fullUrl
      },
      closeSign() {
        this.$emit('closeDialog', false)
      }
    },
  }
</script>

<style lang="scss" scoped>
 .iframe {
   width: 100vw;
   height: 90vh;

 }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/digital_sign.vue